<script setup lang="ts">
import { AppMessageBox, AppSvgIcon } from '@libs/ui';

interface PaxSelectorMessagesProps {
  hasUserMadeAction: boolean;
  shouldShowTicketsWarning: boolean;
  shouldShowRoomSelectionWarning: boolean;
  shouldShowNumberOfVehiclesUpdatedWarning: boolean;
  shouldShowNumberOfVehiclesWillBeUpdatedWarning: boolean;
}

const props = defineProps<PaxSelectorMessagesProps>();
</script>

<template>
  <AppMessageBox
    v-if="
      props.shouldShowNumberOfVehiclesWillBeUpdatedWarning && hasUserMadeAction
    "
    class="message-box"
    :text="$t('planner.pax.ferry_vehicles_will_be_updated_warning')"
  >
    <template #left-icon>
      <AppSvgIcon name="infoCircle" color="color-neutral-70" />
    </template>
  </AppMessageBox>
  <AppMessageBox
    v-if="props.shouldShowNumberOfVehiclesUpdatedWarning && hasUserMadeAction"
    class="message-box"
    :text="$t('planner.pax.ferry_vehicles_updated_warning')"
  >
    <template #left-icon>
      <AppSvgIcon name="infoCircle" color="color-neutral-70" />
    </template>
  </AppMessageBox>
  <AppMessageBox
    v-if="props.shouldShowRoomSelectionWarning && hasUserMadeAction"
    class="message-box"
    :text="$t('planner.pax.rooms_have_not_updated')"
  >
    <template #left-icon>
      <AppSvgIcon name="infoCircle" color="color-neutral-70" />
    </template>
  </AppMessageBox>
</template>

<style scoped lang="scss">
.message-box {
  margin-bottom: var(--spacing-24);
  justify-content: flex-start;
}
</style>
